export const IOS_USERAGENT_AGRI = 'com.xag.agri.ios'
export const ANDROID_USERAGENT_AGRI = 'com.xag.agri.android'

export const IOS_USERAGENT_FARM = 'com.xa.farm.ios'
export const ANDROID_USERAGENT_FARM = 'com.xa.farm.android'

export const IOS_USERAGENT_XFARM = 'com.xa.xfarm.ios'
export const ANDROID_USERAGENT_XFARM = 'com.xa.xfarm.android'

export const IOS_USERAGENT_XAPC = 'com.xa.xapc.ios'
export const IOS_USERAGENT_XAPC4 = 'com.xa.xapc4.ios'
export const ANDROID_USERAGENT_XAPC = 'com.xa.xapc.android'
export const ANDROID_USERAGENT_XAPC4 = 'com.xa.xapc4.android'
export const TABLET_USERAGENT_XAPC = 'com.xa.xapc.tablet'

export const IOS_USERAGENT_XAGAR = 'com.xag.xagar.ios'
export const ANDROID_USERAGENT_XAGAR = 'com.xag.xagar.android'
// export const ANDROID_USERAGENT_XAGAR = 'mozilla/5.0'

export const IOS_USERAGENT = [
  IOS_USERAGENT_AGRI,
  IOS_USERAGENT_FARM,
  IOS_USERAGENT_XFARM,
  IOS_USERAGENT_XAPC,
  IOS_USERAGENT_XAPC4,
  IOS_USERAGENT_XAGAR,
]
export const ANDROID_USERAGENT = [
  ANDROID_USERAGENT_AGRI,
  ANDROID_USERAGENT_FARM,
  ANDROID_USERAGENT_XFARM,
  ANDROID_USERAGENT_XAPC,
  ANDROID_USERAGENT_XAPC4,
  TABLET_USERAGENT_XAPC,
  ANDROID_USERAGENT_XAGAR,
]

/**
 * 农服app
 */
export const AGRI_USERAGENT = [IOS_USERAGENT_AGRI, ANDROID_USERAGENT_AGRI]

/**
 * 农场app
 */
export const FARM_USERAGENT = [
  IOS_USERAGENT_FARM,
  ANDROID_USERAGENT_FARM,
  IOS_USERAGENT_XFARM,
  ANDROID_USERAGENT_XFARM,
]

export const FARM2_USERAGENT = [IOS_USERAGENT_FARM, ANDROID_USERAGENT_FARM]

export const FARM3_USERAGENT = [IOS_USERAGENT_XFARM, ANDROID_USERAGENT_XFARM]
/**
 * 自驾仪app
 */

export const XAPC_USERAGENT = [IOS_USERAGENT_XAPC, ANDROID_USERAGENT_XAPC, TABLET_USERAGENT_XAPC]

export const XAPC4_USERAGENT = [IOS_USERAGENT_XAPC4, ANDROID_USERAGENT_XAPC4]

/**
 * 无人车app
 */

export const XAGAR_USERAGENT = [IOS_USERAGENT_XAGAR, ANDROID_USERAGENT_XAGAR]
